import { FC, memo, useMemo } from "react";
import { DISABLED_OPACITY, getPath, iPoint, iViewBoxProps } from "./LineChart.helpers";

const LineChartArea: FC<{
    points: iPoint[];
    color: string;
    viewport: iViewBoxProps;
    isActive: boolean;
    isPredicted?: boolean;
}> = (
    {
        points,
        color,
        viewport,
        isActive,
        isPredicted = false,
    }
) => {
    const d: string = useMemo(() => {
        if (points.length === 0) return '';

        return getPath([
            { x: points[0].x, y: viewport.height, },
            ...points,
            { x: (points.at(-1) as iPoint).x, y: viewport.height, },
        ]) + ' Z';
    }, [points, viewport]);

    const gradientId = `color-${color}`;

    return (
        <g className="LineChart__area">
            <linearGradient
                id={gradientId}
                gradientTransform="rotate(90)"

            >
                <stop offset="0%" stopColor={color}/>
                <stop offset="100%" stopColor="transparent"/>
            </linearGradient>
            <path
                fillOpacity={isActive ? 1 : DISABLED_OPACITY}
                d={d}
                fill={`url(#${gradientId})`}
                style={{ 
                    opacity: isPredicted ? 0.15 : 0.3,
                    strokeDasharray: isPredicted ? '3,3' : 'none'
                }}
            />
        </g>
    );
};

export default memo(LineChartArea);